import { BLACK_200, BLACK_500, BLACK_900, BLUE_200, BLUE_400, BLUE_500, BLUE_600, WHITE } from '../colors';
var checkboxConfig = {
  theme: 'light',
  labelPosition: 'right',
  size: 'sm',
  checked: false,
  controlState: 'none',
  indeterminate: false,
  spacing: 'SPACING_8',
  checkboxVersion: 'full-width',
  style: {},
  config: {
    size: {
      sm: {
        checkboxSize: 20,
        iconSize: 16,
        labelFontType: 'body-para-sm',
        descriptionFontType: 'body-para-xs'
      },
      md: {
        checkboxSize: 26,
        iconSize: 22,
        labelFontType: 'body-para-md',
        descriptionFontType: 'body-para-sm'
      },
      lg: {
        checkboxSize: 32,
        iconSize: 28,
        labelFontType: 'body-para-lg',
        descriptionFontType: 'body-para-md'
      }
    },
    state: {
      checked: {
        controlState: {
          none: {
            backgroundColor: BLUE_500,
            labelColor: BLACK_900,
            descriptionColor: BLACK_900
          },
          hover: {
            backgroundColor: BLUE_500,
            borderWidth: 1,
            borderColor: BLUE_400,
            labelColor: BLACK_900,
            descriptionColor: BLACK_900
          },
          pressed: {
            backgroundColor: BLUE_600,
            labelColor: BLACK_900,
            descriptionColor: BLACK_900
          },
          disabled: {
            backgroundColor: BLACK_500,
            labelColor: BLACK_500,
            descriptionColor: BLACK_500
          }
        }
      },
      unchecked: {
        controlState: {
          none: {
            backgroundColor: WHITE,
            borderWidth: 1,
            borderColor: BLUE_500,
            labelColor: BLACK_900,
            descriptionColor: BLACK_900
          },
          hover: {
            backgroundColor: BLUE_200,
            borderWidth: 1,
            borderColor: BLUE_400,
            labelColor: BLACK_900,
            descriptionColor: BLACK_900
          },
          pressed: {
            backgroundColor: BLUE_200,
            borderWidth: 1,
            borderColor: BLUE_600,
            labelColor: BLACK_900,
            descriptionColor: BLACK_900
          },
          disabled: {
            backgroundColor: BLACK_200,
            borderWidth: 1,
            borderColor: BLACK_500,
            labelColor: BLACK_500,
            descriptionColor: BLACK_500
          }
        }
      }
    }
  }
};
export default {
  light: checkboxConfig,
  dark: checkboxConfig,
  white: checkboxConfig
};